export default {"src":"/_next/static/media/deco_referral_gift_confetti.4f9158ca.svg","height":190,"width":345,"blurWidth":0,"blurHeight":0};